import './styles/ManageNotifications.scss';
import { AppContext, ExAppContext } from '../../Context';
import { ManageNotifications_SortMap, ManageNotifications_PageMap, ManageNotifications_ModeMap, MemberUser_TypeMap, ManageNotifications_NotificationViewMode } from '../../assets/keyMap';
import { useContext, useState, useRef, useEffect, Fragment } from 'react';
import { IonDateString, IonDateFormat } from '../../components/IonDate';
import { Camera } from '@capacitor/camera';

//components
// import SelectionBox from '../../components/SelectionBox'; --deprecated of unuse
import DateTimePicker from '../../components/DateTimePicker';
import SelectionChecker from '../../components/SelectionChecker';
import ToggleSlider from '../../components/ToggleSlider';

//classes
import Broadcast from '../../classes/broadcast';
import SelectionList from '../../classes/selectionList';
import MemberType from '../../exClasses/memberType';
import CommitteeType from '../../exClasses/committeeType';

//controllers
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';

//muis
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DeleteIcon from '@mui/icons-material/Delete';
import GroupsIcon from '@mui/icons-material/Groups';
import TimerIcon from '@mui/icons-material/Timer';
import NotificationIcon from '@mui/icons-material/Notifications';
import NotificationsPausedIcon from '@mui/icons-material/NotificationsPaused';

const nonstate = {
    controlledImgSize: 500
}

interface Props {

}

const ManageNotifications: React.FC<Props> = ({ }) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [scheduledNotifications, SetScheduledNotifications] = useState([] as Broadcast[]);
    const [currentNotifications, SetCurrentNotifications] = useState([] as Broadcast[]);
    const [pastNotifications, SetPastNotifications] = useState([] as Broadcast[]);
    const [page, SetPage] = useState(ManageNotifications_PageMap.MAIN);
    const [notificationViewMode, SetNotificationViewMode] = useState(ManageNotifications_NotificationViewMode.SCHEDULED);
    const [selectedNotification, SetSelectedNotification] = useState({} as Broadcast);
    const [selectedTargetedViewNotification, SetSelectedTargetedViewNotification] = useState({} as Broadcast);
    const [filter_ScheduledNotifications, SetFilter_ScheduledNotifications] = useState('');
    const [filter_CurrentNotifications, SetFilter_CurrentNotifications] = useState('');
    const [filter_PastNotifications, SetFilter_PastNotifications] = useState('');
    const [filter_searchString, SetFilter_searchString] = useState('');
    //state - filters
    // const [dateSort_Scheduled, SetDateSort_Scheduled] = useState(ManageNotifications_SortMap.DESCENDING);
    // const [dateSort_Current, SetDateSort_Current] = useState(ManageNotifications_SortMap.DESCENDING);
    // const [dateSort_Past, SetDateSort_Past] = useState(ManageNotifications_SortMap.DESCENDING);
    // const [filter_MembershipType, SetFilter_MembershipType] = useState('all');
    // const [filter_AccountType, SetFilter_AccountType] = useState('all');
    // const [filter_CommitteeType, SetFilter_CommitteeType] = useState('all');
    //state - selection list
    // const [MemberTypeSelectionList, SetMemberTypeSelectionList] = useState<SelectionList[]>([] as SelectionList[]);
    // const [MemberUserTypeSelectionList, SetMemberUserTypeSelectionList] = useState<SelectionList[]>([] as SelectionList[]);
    // const [CommitteeTypeSelectionList, SetCommitteeTypeSelectionList] = useState<SelectionList[]>([] as SelectionList[]);

    //state - create - edit menu form
    const [newPosterBase64, SetNewPosterBase64] = useState('');
    const [newTitle, SetNewTitle] = useState('');
    const [newMessage, SetNewMessage] = useState('');
    const [newStartDateTime, SetNewStartDateTime] = useState<Date>(new Date());
    const [newEndDateTime, SetNewEndDateTime] = useState<Date>(new Date());
    const [newTargetedMemberTypeIDs, SetNewTargetedMemberTypeIDs] = useState<string[]>([] as string[]);
    const [newTargetedMemberUserTypes, SetNewTargetedMemberUserTypes] = useState<string[]>([] as string[]);
    const [newTargetedCommitteeTypeIDs, SetNewTargetedCommitteeTypeIDs] = useState<string[]>([] as string[]);
    const [newPublish, SetNewPublish] = useState<boolean>(true);
    //state selection checkers
    const [memberTypeCheckList, SetMemberTypeCheckList] = useState([] as string[]);
    const [memberUserTypeCheckList, SetMemberUserTypeCheckList] = useState([] as string[]);
    const [committeeTypeCheckList, SetCommitteeTypeCheckList] = useState([] as string[]);
    const [memberTypeListCheckings, SetMemberTypeListCheckings] = useState([] as boolean[]);
    const [memberUserTypeListCheckings, SetMemberUserTypeListCheckings] = useState([] as boolean[]);
    const [committeeTypeListCheckings, SetCommitteeTypeListCheckings] = useState([] as boolean[]);
    //refs objects
    const canvasRef = useRef<any>(null);
    const imageRef = useRef<any>(new Image());
    const newPosterBase64Ref = useRef<string>('');

    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);

    //watchers
    //test
    // useEffect(() => {
    //     console.log('ManageNotificationsTest: ' + JSON.stringify(selectedNotification));
    // }, [selectedNotification]);

    useEffect(() => {
        databaseInterfaceController.Queue('fetchAllBroadcasts', [
            ['fetchAllBroadcasts', 'true']
        ]);
    }, []);

    //watch for databaseResultAction
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                switch (mode) {
                    case 'fetchAllBroadcasts':
                        if (!JSON.stringify(res).includes('_false')) {
                            let resObjs = [] as any[];
                            try {
                                resObjs = JSON.parse(res) as any[];
                            } catch {
                                resObjs = res as any[];
                            }
                            const notifications = [] as Broadcast[];
                            resObjs.map((res: any) => {
                                notifications.push(new Broadcast(
                                    res['broadcastID'],
                                    res['poster'],
                                    res['title'],
                                    res['message'],
                                    res['start_datetime'],
                                    res['end_datetime'],
                                    res['action'],
                                    res['targeted_member_typeIDs'],
                                    res['targeted_member_user_types'],
                                    res['targeted_committee_typeIDs'],
                                    res['publishh'],
                                    res['datetime_created'],
                                    false,
                                    false
                                ))
                            });
                            const _scheduledNotifications = [] as Broadcast[];
                            const _currentNotifications = [] as Broadcast[];
                            const _pastNotifications = [] as Broadcast[];
                            const dateNow = new Date();
                            notifications.map((notification: Broadcast) => {
                                if (notification.start_datetime != null && notification.start_datetime > dateNow)
                                    _scheduledNotifications.push(notification)
                                else if (
                                    (notification.start_datetime != null && notification.end_datetime != null)
                                    && (notification.start_datetime <= dateNow && notification.end_datetime > dateNow)
                                ) {
                                    _currentNotifications.push(notification);
                                }
                                else {
                                    _pastNotifications.push(notification);
                                }
                            });
                            SetScheduledNotifications([..._scheduledNotifications]);
                            SetCurrentNotifications([..._currentNotifications]);
                            SetPastNotifications([..._pastNotifications]);
                        } else {
                            console.log('fetchAllBroadcastsErr: ' + res);
                        }
                        break;
                    case 'createBroadcast':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('New notification created');
                            SetPage(ManageNotifications_PageMap.MAIN);

                            databaseInterfaceController.Queue('fetchAllBroadcasts', [
                                ['fetchAllBroadcasts', 'true']
                            ]);
                            databaseInterfaceController.Queue('fetchAssociatedBroadcasts', [
                                ['fetchAssociatedBroadcasts', 'true'],
                                ['dateNow', IonDateString(new Date())],
                                ['userID', appContext.user.userID]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Fail to create notification,\nPlease try again later.');
                            console.log('createBroadcastErr: ' + res);
                        }
                        break;
                    case 'updateBroadcast':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('Successfully updated a notification.');
                            SetPage(ManageNotifications_PageMap.MAIN);

                            databaseInterfaceController.Queue('fetchAllBroadcasts', [
                                ['fetchAllBroadcasts', 'true']
                            ]);

                            databaseInterfaceController.Queue('fetchAssociatedBroadcasts', [
                                ['fetchAssociatedBroadcasts', 'true'],
                                ['dateNow', IonDateString(new Date())],
                                ['userID', appContext.user.userID]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Fail to update notification,\nPlease try again later.');
                            console.log('updateBroadcastErr: ' + res);
                        }
                        break;
                    case 'deleteBroadcast':
                        if (!JSON.stringify(res).includes('_false')) {
                            appContext.SetPopupMessage('Notification deleted');
                            databaseInterfaceController.Queue('fetchAllBroadcasts', [
                                ['fetchAllBroadcasts', 'true']
                            ]);
                            databaseInterfaceController.Queue('fetchAssociatedBroadcasts', [
                                ['fetchAssociatedBroadcasts', 'true'],
                                ['dateNow', IonDateString(new Date())],
                                ['userID', appContext.user.userID]
                            ]);
                        } else {
                            appContext.SetPopupMessage('Fail to delete the selected notification.\nPlease try again later.');
                            console.log('deleteBroadcastErr: ' + res);
                        }
                        break;
                }
            }
            switch (appContext.databaseActionModeQueue[0]) {
                case 'fetchAllBroadcasts':
                case 'createBroadcast':
                case 'updateBroadcast':
                case 'deleteBroadcast':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //watch for page & selectedNotification upate
    useEffect(() => {
        switch (page) {
            case ManageNotifications_PageMap.MAIN:
            case ManageNotifications_PageMap.CREATE_EDIT_MENU:
                ResetCreateEditForm();
                break;
        }
    }, [page, selectedNotification]);

    //watch for memberTypes, committeeTypes, memberUserTypes update reset selectionList and selectionCheckings
    useEffect(() => {
        //Process memberTypes
        if (exAppContext.memberTypes.length > 0) {
            const _memberTypeSelectionList = [] as SelectionList[];
            const _memberTypeCheckList = [] as string[];
            const _memberTypeListCheckings = [] as boolean[];

            exAppContext.memberTypes.map((memberType: MemberType) => {
                _memberTypeSelectionList.push({ key: memberType.member_typeID, value: ToInitialCap(memberType.label) } as SelectionList);
                _memberTypeCheckList.push(ToInitialCap(memberType.label));
                _memberTypeListCheckings.push(false);
            });

            // SetMemberTypeSelectionList([..._memberTypeSelectionList]);
            SetMemberTypeCheckList([..._memberTypeCheckList]);
            SetMemberTypeListCheckings([..._memberTypeListCheckings]);
        }
        //Process memberUserTypes
        if (Object.keys(MemberUser_TypeMap).length > 0) {
            const _memberUserTypeSelectionList = [] as SelectionList[];
            const _memberUserTypeCheckList = [] as string[];
            const _memberUserTypeListCheckings = [] as boolean[];

            Object.keys(MemberUser_TypeMap).map((key: string) => {
                _memberUserTypeSelectionList.push({ key: MemberUser_TypeMap[key as keyof typeof MemberUser_TypeMap], value: ToInitialCap(key) } as SelectionList);
                _memberUserTypeCheckList.push(ToInitialCap(key));
                _memberUserTypeListCheckings.push(false);
            });

            // SetMemberUserTypeSelectionList([..._memberUserTypeSelectionList]);
            SetMemberUserTypeCheckList([..._memberUserTypeCheckList]);
            SetMemberUserTypeListCheckings([..._memberUserTypeListCheckings]);
        }
        //Process committeeTypes
        if (exAppContext.committeeTypes.length > 0) {
            const _committeeTypeSelectionList = [] as SelectionList[];
            const _committeeTypeCheckList = [] as string[];
            const _committeeTypeListCheckings = [] as boolean[];

            exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
                _committeeTypeSelectionList.push({ key: committeeType.committee_typeID, value: ToInitialCap(committeeType.label) } as SelectionList);
                _committeeTypeCheckList.push(ToInitialCap(committeeType.label));
                _committeeTypeListCheckings.push(false);
            });

            // SetCommitteeTypeSelectionList([..._committeeTypeSelectionList]);
            SetCommitteeTypeCheckList([..._committeeTypeCheckList]);
            SetCommitteeTypeListCheckings([..._committeeTypeListCheckings]);
        }
    }, [exAppContext.memberTypes, MemberUser_TypeMap, exAppContext.committeeTypes]);

    //watch for list checkings update form vars
    useEffect(() => {
        const _newTargetedMemberTypeIDs = [] as string[];
        const _newTargetedMemberUserTypes = [] as string[];
        const _newTargetedCommitteeTypeIDs = [] as string[];

        memberTypeCheckList.map((memberTypeLbl: string, i: number) => {
            if (memberTypeListCheckings[i])
                _newTargetedMemberTypeIDs.push(GetMemberTypeIDByLabel(memberTypeLbl));
        });
        SetNewTargetedMemberTypeIDs([..._newTargetedMemberTypeIDs]);

        memberUserTypeCheckList.map((memberUserTypeLabel: string, i: number) => {
            if (memberUserTypeListCheckings[i])
                _newTargetedMemberUserTypes.push(GetMemberUserTypeByLabel(memberUserTypeLabel));
        });
        SetNewTargetedMemberUserTypes([..._newTargetedMemberUserTypes]);

        committeeTypeCheckList.map((committeeTypeLabel: string, i: number) => {
            if (committeeTypeListCheckings[i])
                _newTargetedCommitteeTypeIDs.push(GetCommitteeTypeIDByLabel(committeeTypeLabel));
        });
        SetNewTargetedCommitteeTypeIDs([..._newTargetedCommitteeTypeIDs]);

    }, [memberTypeListCheckings, memberUserTypeListCheckings, committeeTypeListCheckings]);

    //ui functions
    const OnCreateUpdateNotificationClicked = () => {
        if (
            newTitle.length > 3
            && newMessage.length > 3
            && IsAtleastOneTargetGroupSelected()
        ) {
            if (
                newTargetedMemberTypeIDs.length > 0
                || newTargetedMemberUserTypes.length > 0
                || SetNewTargetedCommitteeTypeIDs.length > 0
            ) {
                appContext.SetWaitScreenShouldShow(true);
                setTimeout(() => {
                    if (Object.keys(selectedNotification).length == 0) {
                        //CREATE new notification
                        databaseInterfaceController.Queue('createBroadcast', [
                            ['createBroadcast', 'true'],
                            ['initiatorID', appContext.user.userID],
                            ['posterBase64', newPosterBase64, false],
                            ['title', newTitle],
                            ['message', newMessage],
                            ['start_datetime', IonDateString(newStartDateTime)],
                            ['end_datetime', IonDateString(newEndDateTime)],
                            ['targeted_member_typeIDs', newTargetedMemberTypeIDs.join(',')],
                            ['targeted_member_user_types', newTargetedMemberUserTypes.join(',')],
                            ['targeted_committee_typeIDs', newTargetedCommitteeTypeIDs.join(',')],
                            ['publish', newPublish ? '1' : '0']
                        ]);
                    } else {
                        //UPDATE existing notification
                        databaseInterfaceController.Queue('updateBroadcast', [
                            ['updateBroadcast', 'true'],
                            ['initiatorID', appContext.user.userID],
                            ['broadcastID', selectedNotification.broadcastID],
                            ['posterBase64', newPosterBase64, false],
                            ['poster', selectedNotification.poster],
                            ['title', newTitle],
                            ['message', newMessage],
                            ['start_datetime', IonDateString(newStartDateTime)],
                            ['end_datetime', IonDateString(newEndDateTime)],
                            ['targeted_member_typeIDs', newTargetedMemberTypeIDs.join(',')],
                            ['targeted_member_user_types', newTargetedMemberUserTypes.join(',')],
                            ['targeted_committee_typeIDs', newTargetedCommitteeTypeIDs.join(',')],
                            ['publish', newPublish ? '1' : '0']
                        ]);
                    }
                }, 500);
            }
        } else {
            appContext.SetPopupMessage('All fields marked with (*) are compulsory');
        }
    }
    const OnCreateEditMenuCloseClicked = () => {
        SetSelectedNotification({} as Broadcast);
        SetPage(ManageNotifications_PageMap.MAIN);
    }
    const OnBrowseImageClicked = async () => {
        appContext.SetAppStateChangeWatch(false);

        await Camera.pickImages({ limit: 1 }).then((res: any) => {
            const _res = res.photos[0];
            Resize(_res.webPath ? _res.webPath : '');
        });
    }
    const OnDeleteNotificationClicked = (notification: Broadcast) => {
        appContext.SetPopupMessage('Are you sure you want to delete the selected notification?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            databaseInterfaceController.Queue('deleteBroadcast', [
                ['deleteBroadcast', 'true'],
                ['initiatorID', appContext.user.userID],
                ['broadcastID', notification.broadcastID],
                ['posterUrl', notification.poster]
            ]);
        }, () => { }]);
    }

    //render functions
    const RenderPage = () => {
        switch (page) {
            default:
            case ManageNotifications_PageMap.MAIN:
                return RenderMainPage();
            case ManageNotifications_PageMap.CREATE_EDIT_MENU:
                return RenderCreateEditNotificationMenu();
        }
    }
    const RenderMainPage = () => {
        return (
            <div className='page main'>
                {/* <div className='page-scroll'>
                    {
                        RenderScheduledNotifications()
                    }
                    {
                        RenderCurrentNotifications()
                    }
                    {
                        RenderPastNotifications()
                    }
                </div> */}
                <div className='option-panel'>
                    <div className='option-panel-row'>
                        <button className={'option-btn ' + (notificationViewMode == ManageNotifications_NotificationViewMode.SCHEDULED ? 'selected' : '')} onClick={() => SetNotificationViewMode(ManageNotifications_NotificationViewMode.SCHEDULED)}>
                            <TimerIcon />
                            {
                                notificationViewMode == ManageNotifications_NotificationViewMode.SCHEDULED ?
                                    "Scheduled Notifications"
                                    :
                                    ""
                            }
                        </button>
                        <button className={'option-btn ' + (notificationViewMode == ManageNotifications_NotificationViewMode.CURRENT ? 'selected' : '')} onClick={() => SetNotificationViewMode(ManageNotifications_NotificationViewMode.CURRENT)}>
                            <NotificationIcon />
                            {
                                notificationViewMode == ManageNotifications_NotificationViewMode.CURRENT ?
                                    "Current Notifications"
                                    :
                                    ""
                            }
                        </button>
                        <button className={'option-btn ' + (notificationViewMode == ManageNotifications_NotificationViewMode.PAST ? 'selected' : '')} onClick={() => SetNotificationViewMode(ManageNotifications_NotificationViewMode.PAST)}>
                            <NotificationsPausedIcon />
                            {
                                notificationViewMode == ManageNotifications_NotificationViewMode.PAST ?
                                    "Past Notifications"
                                    :
                                    ""
                            }
                        </button>
                    </div>
                    <div className='option-search-bar'>
                        <input className='search-in' value={filter_searchString} onChange={(e: any) => SetFilter_searchString(e.target.value)} placeholder='type in something to search' onFocus={() => SetFilter_searchString('')}/>
                        <SearchIcon />
                    </div>
                </div>
                <div className='page-scroll'>
                    {
                        notificationViewMode == ManageNotifications_NotificationViewMode.SCHEDULED ?
                            RenderScheduledNotifications()
                            :
                            (
                                notificationViewMode == ManageNotifications_NotificationViewMode.CURRENT ?
                                    RenderCurrentNotifications()
                                    :
                                    (
                                        notificationViewMode == ManageNotifications_NotificationViewMode.PAST ?
                                            RenderPastNotifications()
                                            :
                                            null
                                    )
                            )
                    }
                </div>
                <button className='create-btn' onClick={() => SetPage(ManageNotifications_PageMap.CREATE_EDIT_MENU)}><AddIcon />Create Notification</button>
            </div>
        )
    }
    const RenderCreateEditNotificationMenu = () => {
        const mode = Object.keys(selectedNotification).length > 0 ? ManageNotifications_ModeMap.EDIT : ManageNotifications_ModeMap.CREATE;
        let imgSrc = '';

        if (mode == ManageNotifications_ModeMap.EDIT && selectedNotification.poster.length > 0 && newPosterBase64.length == 0)
            imgSrc = selectedNotification.poster;
        else
            imgSrc = newPosterBase64;

        return (
            <div className='page create-edit-menu'>
                <span className='menu-title'>{mode == ManageNotifications_ModeMap.CREATE ? 'Create Notification' : 'Edit Notification'}</span>
                <div className='menu-scroll'>
                    {/** title */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Title *</span>
                        <input className='menu-in' value={newTitle} onChange={(e: any) => SetNewTitle(e.target.value)} placeholder='Notification title here.' />
                    </div>
                    {/** poster */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Poster</span>
                        <div className='menu-img-block'>
                            {
                                imgSrc.length > 0 ?
                                    <img className='menu-img' src={imgSrc} />
                                    :
                                    <div className='menu-img' />
                            }
                            <button className='menu-btn' onClick={() => OnBrowseImageClicked()}>Browse Poster Image</button>
                        </div>
                    </div>
                    {/** message */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Message *</span>
                        <textarea className='menu-area' value={newMessage} onChange={(e: any) => SetNewMessage(e.target.value)} placeholder='Notification message here.' />
                    </div>
                    {/** start date */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Start Date Time *</span>
                        <div className='menu-datetime-picker'>
                            <DateTimePicker dateTime={newStartDateTime} SetDateTime={SetNewStartDateTime} mode='datetime' />
                        </div>
                    </div>
                    {/** end date */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>End Date Time *</span>
                        <div className='menu-datetime-picker'>
                            <DateTimePicker dateTime={newEndDateTime} SetDateTime={SetNewEndDateTime} mode='datetime' />
                        </div>
                    </div>
                    {/** targeted member type */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Targeted Membership Type *</span>
                        <div className='menu-selection-checker'>
                            <SelectionChecker checkList={memberTypeCheckList} checkings={memberTypeListCheckings} SetCheckings={SetMemberTypeListCheckings} placeholder='Select Membership Type' />
                        </div>
                    </div>
                    {/** targeted member user type */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Targeted Account Type *</span>
                        <div className='menu-selection-checker'>
                            <SelectionChecker checkList={memberUserTypeCheckList} checkings={memberUserTypeListCheckings} SetCheckings={SetMemberUserTypeListCheckings} placeholder='Select Account Type' />
                        </div>
                    </div>
                    {/** targeted committee type */}
                    <div className='menu-col'>
                        <span className='menu-lbl'>Targeted Committee Type *</span>
                        <div className='menu-selection-checker'>
                            <SelectionChecker checkList={committeeTypeCheckList} checkings={committeeTypeListCheckings} SetCheckings={SetCommitteeTypeListCheckings} placeholder='Select Committee Type' />
                        </div>
                    </div>
                    {/** publish toggle */}
                    <div className='menu-col'>
                        <div className='menu-toggle'>
                            <ToggleSlider labelA='Unpublish' labelB='Publish' toggled={newPublish} SetToggled={SetNewPublish}/>
                        </div>
                    </div>
                </div>
                <div className='menu-option-panel'>
                    <button className='menu-option-btn' onClick={() => OnCreateUpdateNotificationClicked()}>{mode == ManageNotifications_ModeMap.CREATE ? 'Create' : 'Update'}</button>
                </div>
                <button className='menu-close-btn' onClick={() => OnCreateEditMenuCloseClicked()}><CloseIcon /></button>
            </div>
        )
    }
    const RenderScheduledNotifications = () => {
        const notifications = FilterNotifications(scheduledNotifications);
        // return (
        //     <div className='notifications-block'>
        //         <span className='notifications-block-title'>Scheduled Notifications</span>
        //         <div className='notifications-search-panel'>
        //             <input className='notifications-search-bar' value={filter_ScheduledNotifications} onChange={(e: any) => SetFilter_ScheduledNotifications(e.target.value)} placeholder='search for scheduled notifications' />
        //             <SearchIcon />
        //         </div>
        //         <div className='notifications-scroll'>
        //             {
        //                 notifications.length > 0 ?
        //                     notifications.map((notification: Broadcast) => {
        //                         return RenderNotificationCard(notification)
        //                     })
        //                     :
        //                     <span className='no-record-lbl'>No scheduledNotifications found<br />Come back and check again later.</span>
        //             }
        //         </div>
        //     </div>
        // ) ---deprecated

        return (
            <Fragment>
                {
                    notifications.length > 0 ?
                        notifications.map((notification: Broadcast, i: number) => {
                            return RenderNotificationCard(notification, i)
                        })
                        :
                        <span className='no-record-lbl'>No scheduledNotifications found<br />Come back and check again later.</span>
                }
            </Fragment>
        )
    }
    const RenderCurrentNotifications = () => {
        const notifications = FilterNotifications(currentNotifications);
        // return (
        //     <div className='notifications-block'>
        //         <span className='notifications-block-title'>Current Notifications</span>
        //         <div className='notifications-search-panel'>
        //             <input className='notifications-search-bar' value={filter_CurrentNotifications} onChange={(e: any) => SetFilter_CurrentNotifications(e.target.value)} placeholder='search for current notifications' />
        //             <SearchIcon />
        //         </div>
        //         <div className='notifications-scroll'>
        //             {
        //                 notifications.length > 0 ?
        //                     notifications.map((notification: Broadcast) => {
        //                         return RenderNotificationCard(notification)
        //                     })
        //                     :
        //                     <span className='no-record-lbl'>No scheduledNotifications found<br />Come back and check again later.</span>
        //             }
        //         </div>
        //     </div>
        // ) ---deprecated

        return (
            <Fragment>
                {
                    notifications.length > 0 ?
                        notifications.map((notification: Broadcast, i:number) => {
                            return RenderNotificationCard(notification, i)
                        })
                        :
                        <span className='no-record-lbl'>No scheduledNotifications found<br />Come back and check again later.</span>
                }
            </Fragment>
        )
    }
    const RenderPastNotifications = () => {
        const notifications = FilterNotifications(pastNotifications);
        // return (
        //     <div className='notifications-block'>
        //         <span className='notifications-block-title'>Past Notifications</span>
        //         <div className='notifications-search-panel'>
        //             <input className='notifications-search-bar' value={filter_PastNotifications} onChange={(e: any) => SetFilter_PastNotifications(e.target.value)} placeholder='search for past notifications' />
        //             <SearchIcon />
        //         </div>
        //         <div className='notifications-scroll'>
        //             {
        //                 notifications.length > 0 ?
        //                     notifications.map((notification: Broadcast) => {
        //                         return RenderNotificationCard(notification)
        //                     })
        //                     :
        //                     <span className='no-record-lbl'>No scheduledNotifications found<br />Come back and check again later.</span>
        //             }
        //         </div>
        //     </div>
        // ) ---deprecated
        return (
            <Fragment>
                {
                    notifications.length > 0 ?
                        notifications.map((notification: Broadcast, i: number) => {
                            return RenderNotificationCard(notification, i)
                        })
                        :
                        <span className='no-record-lbl'>No scheduledNotifications found<br />Come back and check again later.</span>
                }
            </Fragment>
        )
    }
    const RenderNotificationCard = (notification: Broadcast, i: number) => {
        return (
            <div className='notification-card' key={'notification-card-' + i}>
                <div className='card-header-row'>
                    <span className='card-date-lbl'>{IonDateString(notification.datetime_created, IonDateFormat.MALAYSIA_STANDARD_DATE)}</span>
                </div>
                <div className='card-body-row'>
                    {/** Col 1 */}
                    <div className='card-body-col ex'>
                        <span className='card-title-lbl'>{notification.title}</span>
                        <span className='card-message-lbl'>{notification.message}</span>
                        <span className='card-datetime-lbl'>
                            <DateRangeIcon />
                            FROM {IonDateString(notification.start_datetime, IonDateFormat.MALAYSIA_STANDARD)}
                        </span>
                        <span className='card-datetime-lbl'>
                            <DateRangeIcon />
                            TO {IonDateString(notification.end_datetime, IonDateFormat.MALAYSIA_STANDARD)}
                        </span>
                    </div>
                    {/** Col 2 */}
                    <div className='card-body-col'>
                        {
                            notification.poster.length > 0 ?
                                <img className='card-poster-img' src={notification.poster} />
                                :
                                <span className='card-poster-lbl'>No Poster<br />To Show</span>
                        }
                        <div className='card-option-panel'>
                            <button className='card-option-btn' onClick={() => SetSelectedTargetedViewNotification(notification)}><GroupsIcon />{GetViewableGroupCount(notification)}</button>
                            <button className='card-option-btn ex' onClick={() => { SetSelectedNotification(notification); SetPage(ManageNotifications_PageMap.CREATE_EDIT_MENU); }}>Edit</button>
                        </div>
                    </div>
                    <button className='card-delete-btn' onClick={() => OnDeleteNotificationClicked(notification)}><DeleteIcon /></button>
                    <span className='card-publish-status-lbl'>{notification.publish ? 'published' : 'unpublished'}</span>
                </div>
            </div>
        )
    }
    const RenderViewNotificationTargetedListMenu = () => {
        return (
            <div className='menu'>
                <div className='menu-ui-block-mask' />
                <div className='menu-form'>
                    <div className='menu-scroll'>
                        {
                            selectedTargetedViewNotification.targeted_member_typeIDs.length > 0 ?
                                <Fragment>
                                    <span className='menu-lbl'>Targeted Membership Types</span>
                                    {
                                        selectedTargetedViewNotification.targeted_member_typeIDs.map((memberTypeID: string) => {
                                            return (
                                                <span className='menu-txt'>{GetMemberTypeLabelByID(memberTypeID)}</span>
                                            )
                                        })
                                    }
                                </Fragment>
                                :
                                null
                        }
                        {
                            selectedTargetedViewNotification.targeted_member_user_types.length > 0 ?
                                <Fragment>
                                    <span className='menu-lbl'>Targeted Account Types</span>
                                    {
                                        selectedTargetedViewNotification.targeted_member_user_types.map((userType: string) => {
                                            return (
                                                <span className='menu-txt'>{GetMemberUserTypeLabelByID(userType)}</span>
                                            )
                                        })
                                    }
                                </Fragment>
                                :
                                null
                        }
                        {
                            selectedTargetedViewNotification.targeted_committee_typeIDs.length > 0 ?
                                <Fragment>
                                    <span className='menu-lbl'>Viewable Committee Types</span>
                                    {
                                        selectedTargetedViewNotification.targeted_committee_typeIDs.map((committeeTypeID: string) => {
                                            return (
                                                <span className='menu-txt'>{GetCommitteeTypeLabelByID(committeeTypeID)}</span>
                                            )
                                        })
                                    }
                                </Fragment>
                                :
                                null
                        }
                    </div>
                    <button className='menu-close-btn' onClick={() => SetSelectedTargetedViewNotification({} as Broadcast)}><CloseIcon /></button>
                </div>
            </div>
        );
    }

    //reset form functions
    const ResetCreateEditForm = () => {
        const mode = Object.keys(selectedNotification).length > 0 ? ManageNotifications_ModeMap.EDIT : ManageNotifications_ModeMap.CREATE;

        switch (mode) {
            case ManageNotifications_ModeMap.CREATE:
                SetNewPosterBase64('');
                SetNewTitle('');
                SetNewMessage('');
                SetNewStartDateTime(new Date());
                SetNewEndDateTime(new Date());
                SetNewTargetedMemberTypeIDs([]);
                SetNewTargetedMemberUserTypes([]);
                SetNewTargetedCommitteeTypeIDs([]);
                SetMemberTypeListCheckings([...GetResetMemberTypeListCheckings(memberTypeListCheckings, memberTypeCheckList, [])]);
                SetMemberUserTypeListCheckings([...GetResetMemberUserTypeListCheckings(memberUserTypeListCheckings, memberUserTypeCheckList, [])]);
                SetCommitteeTypeListCheckings([...GetResetCommitteeTypeListCheckings(committeeTypeListCheckings, committeeTypeCheckList, [])]);
                SetNewPublish(true);
                break;
            case ManageNotifications_ModeMap.EDIT:
                SetNewPosterBase64('');
                SetNewTitle(selectedNotification.title);
                SetNewMessage(selectedNotification.message);
                SetNewStartDateTime(selectedNotification.start_datetime != null ? selectedNotification.start_datetime : new Date());
                SetNewEndDateTime(selectedNotification.end_datetime != null ? selectedNotification.end_datetime : new Date());
                SetNewTargetedMemberTypeIDs(selectedNotification.targeted_member_typeIDs);
                SetNewTargetedMemberUserTypes(selectedNotification.targeted_member_user_types);
                SetNewTargetedCommitteeTypeIDs(selectedNotification.targeted_committee_typeIDs);
                SetMemberTypeListCheckings([...GetResetMemberTypeListCheckings(memberTypeListCheckings, memberTypeCheckList, selectedNotification.targeted_member_typeIDs)]);
                SetMemberUserTypeListCheckings([...GetResetMemberUserTypeListCheckings(memberUserTypeListCheckings, memberUserTypeCheckList, selectedNotification.targeted_member_user_types)]);
                SetCommitteeTypeListCheckings([...GetResetCommitteeTypeListCheckings(committeeTypeListCheckings, committeeTypeCheckList, selectedNotification.targeted_committee_typeIDs)]);
                SetNewPublish(selectedNotification.publish);
                break;
        }
    }
    const GetResetMemberTypeListCheckings = (checkings: boolean[], checkList: string[], exceptions: string[]) => {
        const res = [] as boolean[];
        checkings.map((checking: boolean, i: number) => {
            if (exceptions.join(',').includes(GetMemberTypeIDByLabel(checkList[i])))
                res.push(true);
            else
                res.push(false);
        });
        return res;
    }
    const GetResetMemberUserTypeListCheckings = (checkings: boolean[], checkList: string[], exceptions: string[]) => {
        const res = [] as boolean[];
        checkings.map((checking: boolean, i: number) => {
            if (exceptions.join(',').includes(GetMemberUserTypeByLabel(checkList[i])))
                res.push(true);
            else
                res.push(false);
        });
        return res;
    }
    const GetResetCommitteeTypeListCheckings = (checkings: boolean[], checkList: string[], exceptions: string[]) => {
        const res = [] as boolean[];
        checkings.map((checking: boolean, i: number) => {
            if (exceptions.join(',').includes(GetCommitteeTypeIDByLabel(checkList[i])))
                res.push(true);
            else
                res.push(false);
        });
        return res;
    }

    //exe functions
    const Resize = (imgUrl: string) => {
        canvasRef.current = document.createElement('canvas');
        const context = canvasRef.current.getContext('2d');

        //process image
        if (imgUrl != '') {
            imageRef.current.src = imgUrl;
            imageRef.current.onload = () => {
                //get image profile
                let [orientation, img_width, img_height] = GetImageProfile(imageRef.current);
                const w_h_ratio = img_width / img_height;
                const shouldDrawTillXPos = (orientation == 'portrait' ? nonstate.controlledImgSize : w_h_ratio * nonstate.controlledImgSize);
                const shouldDrawTillYPos = (orientation == 'landscape' ? nonstate.controlledImgSize : nonstate.controlledImgSize / w_h_ratio);

                if (canvasRef.current != undefined) {
                    canvasRef.current.width = shouldDrawTillXPos;
                    canvasRef.current.height = shouldDrawTillYPos;
                }

                if (context) {
                    context.drawImage(
                        imageRef.current,
                        // orientation == 'portrait' ? 0 : offset, //grab ori image pos X
                        // orientation == 'landscape' ? 0 : offset,//grab ori image pos Y
                        0, 0,
                        img_width, img_height,
                        0, 0, //start draw from canvas pos 
                        shouldDrawTillXPos, shouldDrawTillYPos //draw till canvas dimension
                    );
                    if (canvasRef.current) {
                        const imgBase64String = canvasRef.current.toDataURL();
                        newPosterBase64Ref.current = imgBase64String;
                        SetNewPosterBase64(newPosterBase64Ref.current);
                    }
                }
            }
        }
    }
    const GetImageProfile = (image: HTMLImageElement): [string, number, number] => {

        let orientation: string = '';
        let img_width: number = 0;
        let img_height: number = 0;

        if (image.height >= image.width) {
            //is a portrait or square
            orientation = 'portrait';
        } else {
            //is a landscape
            orientation = 'landscape';
        }
        img_width = image.width; img_height = image.height;

        return [orientation, img_width, img_height];
    }
    const GetViewableGroupCount = (notification: Broadcast) => {
        return notification.targeted_committee_typeIDs.length + notification.targeted_member_typeIDs.length + notification.targeted_member_user_types.length;
    }
    const GetMemberTypeIDByLabel = (label: string) => {
        let res = '';
        exAppContext.memberTypes.map((type: MemberType) => {
            if (label.toLowerCase() == type.label.toLowerCase())
                res = type.member_typeID;
        });
        return res;
    }
    const GetMemberTypeLabelByID = (id: string) => {
        let res = '';
        exAppContext.memberTypes.map((memberType: MemberType) => {
            if (memberType.member_typeID == id)
                res = ToInitialCap(memberType.label);
        });
        return res;
    }
    const GetMemberUserTypeByLabel = (label: string) => {
        if (MemberUser_TypeMap[label.toUpperCase() as keyof typeof MemberUser_TypeMap] != undefined) {
            return MemberUser_TypeMap[label.toUpperCase() as keyof typeof MemberUser_TypeMap];
        } else {
            return '';
        }
    }
    const GetMemberUserTypeLabelByID = (id: string) => {
        let res = '';
        Object.keys(MemberUser_TypeMap).map((key: string) => {
            if (MemberUser_TypeMap[key as keyof typeof MemberUser_TypeMap].toString() == id)
                res = ToInitialCap(key);
        });
        return res;
    }
    const GetCommitteeTypeIDByLabel = (label: string) => {
        let res = '';
        exAppContext.committeeTypes.map((type: CommitteeType) => {
            if (label.toLowerCase() == type.label.toLowerCase())
                res = type.committee_typeID;
        });
        return res;
    }
    const GetCommitteeTypeLabelByID = (id: string) => {
        let res = '';
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.committee_typeID == id)
                res = ToInitialCap(committeeType.label);
        });
        return res;
    }
    // const FilterScheduledNotifications = (notifications: Broadcast[]) => {
    //     const res = [] as Broadcast[];
    //     notifications.map((notification: Broadcast) => {
    //         if (notification.title.includes(filter_ScheduledNotifications) || notification.message.includes(filter_ScheduledNotifications))
    //             res.push(notification);
    //     });
    //     return res;
    // }
    // const FilterCurrentNotifications = (notifications: Broadcast[]) => {
    //     const res = [] as Broadcast[];
    //     notifications.map((notification: Broadcast) => {
    //         if (notification.title.includes(filter_CurrentNotifications) || notification.message.includes(filter_CurrentNotifications))
    //             res.push(notification);
    //     });
    //     return res;
    // }
    // const FilterPastNotifications = (notifications: Broadcast[]) => {
    //     const res = [] as Broadcast[];
    //     notifications.map((notification: Broadcast) => {
    //         if (notification.title.includes(filter_PastNotifications) || notification.message.includes(filter_PastNotifications))
    //             res.push(notification);
    //     });
    //     return res;
    // }
    const FilterNotifications = (notifications: Broadcast[]) => {
        let res = [] as Broadcast[];
        if(filter_searchString != '') {
            notifications.map((notification: Broadcast) => {
                if(
                    notification.title.toLocaleLowerCase().includes(filter_searchString.toLowerCase())
                    || notification.message.toLocaleLowerCase().includes(filter_searchString.toLowerCase())
                ) {
                    res.push(notification);
                }
            });
        } else {
            res = notifications;
        }
        return res;
    }

    //conversion functions
    const ToInitialCap = (value: string) => {
        return value.substring(0, 1).toUpperCase() + value.substring(1, value.length).toLowerCase();
    }
    // const ToBase64String = (url: string, AssignAction: any) => {
    //     fetch(url)
    //         .then(response => response.blob())  // Get image as Blob
    //         .then(blob => {
    //             const reader = new FileReader();
    //             reader.onloadend = function () {
    //                 // Convert the image to base64 string
    //                 if (reader.result != null)
    //                     AssignAction((reader.result as string).split(',')[1]);
    //             };
    //             reader.readAsDataURL(blob);  // Convert blob to base64 string
    //         })
    //         .catch(error => console.error('Error fetching image:', error));
    // } ---deprecated

    //checking functions
    const IsAtleastOneTargetGroupSelected = () => {
        if (
            newTargetedCommitteeTypeIDs.length > 0
            || newTargetedMemberTypeIDs.length > 0
            || newTargetedMemberUserTypes.length > 0
        ) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <div className='ManageNotifications'>
            {
                RenderPage()
            }
            {
                Object.keys(selectedTargetedViewNotification).length > 0 ?
                    RenderViewNotificationTargetedListMenu()
                    :
                    null
            }
        </div>
    )
}
export default ManageNotifications;